/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Bo_DatInputs */

const en_case_field_bo_dat = /** @type {(inputs: Case_Field_Bo_DatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Police report (BO) or traffic accident declaration (DAT)`)
};

const pt_br2_case_field_bo_dat = /** @type {(inputs: Case_Field_Bo_DatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boletim de Ocorrência (BO) ou Declaração de Acidente de Trânsito (DAT)`)
};

/**
* | output |
* | --- |
* | "Police report (BO) or traffic accident declaration (DAT)" |
*
* @param {Case_Field_Bo_DatInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_bo_dat = /** @type {((inputs?: Case_Field_Bo_DatInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Bo_DatInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_bo_dat(inputs)
	return pt_br2_case_field_bo_dat(inputs)
});